import { render, staticRenderFns } from "./ConfirmationCarrierPickup.vue?vue&type=template&id=12998464"
import script from "./ConfirmationCarrierPickup.vue?vue&type=script&lang=js"
export * from "./ConfirmationCarrierPickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports